export const stock = {
	title: "ESTOQUE",
	fields: {
		isStockable: {
			label: "Produto estocável?",
			placeholder: "Sim",
			tooltip:
				"Produtos estocáveis são aqueles que ficam armazenados em estoque até serem vendidos ou utilizados.",
			options: {
				yes: "Sim",
				no: "Não",
			},
		},
		stockControlledBy: {
			label: "Estoque controlado por:",
			placeholder: "Unidades",
			options: {
				gram: "Gramas",
				kilogram: "Kilogramas",
				liter: "Litros",
				milliliter: "Mililitros",
				unit: "Unidades",
			},
		},
		conversionRule: {
			label: "Regra de conversão",
			tooltip:
				"Defina como unidades de venda se convertem em unidades de estoque. Ex: 1 garrafa = 1 litro",
			unitLabel: "1 unidade",
			equivalentTo: "equivale a:",
		},
		conversionQuantity: {
			label: "Quantidade",
			placeholder: "750",
		},
		conversionUnit: {
			label: "Unidade de medida",
			placeholder: "Mililitros",
			options: {
				gram: "Gramas",
				kilogram: "Kilogramas",
				liter: "Litros",
				milliliter: "Mililitros",
			},
		},
	},
	messages: {
		nonStockableWarning:
			"Produtos não estocaveis <strong>não aparecerão nos relatórios de estoque</strong>",
	},
};
